import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBriefcase,
	faBuilding,
	faClockRotateLeft,
	faIdCard,
	faLock,
	faPenToSquare,
	faShieldHalved,
	faStar,
	faUmbrellaBeach,
	faUserLock,
	faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import { groupScopes } from "../../../Integrations/HiBob/scopes";

const SCOPE_ICONS = {
	"employee_data:read": faUsers,
	"employee_data.history:read": faClockRotateLeft,
	"employee_data.sensitive:read": faIdCard,
	"employee_data.sensitive.history:read": faUserLock,
	"company.metadata:read": faBuilding,
	"job_catalog:read": faBriefcase,
	"job_catalog.skills:read": faStar,
	"timeoff:read": faUmbrellaBeach,
	"timeoff:write": faPenToSquare,
	"timeoff.sensitive:read": faLock,
};

function AccessCard({ scopes }) {
	const { t } = useTranslation();
	const groups = groupScopes(scopes, t);

	return (
		<Card data-testid="hibob-access-card">
			<CardHeader>
				<h2 className="hibob-card-title">{t("hibob-access-title")}</h2>
			</CardHeader>
			<CardBody>
				{groups.length === 0 ? (
					<p className="hibob-muted mb-0">{t("hibob-no-permissions")}</p>
				) : (
					groups.map(({ group, title, items }) => (
						<section key={group} className="hibob-scope-group" aria-labelledby={`hibob-group-${group}`}>
							<h3 id={`hibob-group-${group}`} className="hibob-group-title">
								{title}
							</h3>
							<ul className="list-unstyled mb-0">
								{items.map((item) => (
									<li key={item.scope} className="hibob-scope">
										<FontAwesomeIcon
											icon={SCOPE_ICONS[item.scope] || faShieldHalved}
											className="hibob-scope-icon"
											fixedWidth
											aria-hidden="true"
										/>
										<div>
											<div className="hibob-scope-label">{item.label}</div>
											{item.purpose && <div className="hibob-scope-purpose">{item.purpose}</div>}
										</div>
										<span className="hibob-access-tag">
											{item.access === "readWrite" ? t("hibob-access-read-write") : t("hibob-access-read")}
										</span>
									</li>
								))}
							</ul>
						</section>
					))
				)}
			</CardBody>
			<CardFooter>{t("hibob-access-footer")}</CardFooter>
		</Card>
	);
}

export default AccessCard;
